import { Box, Stack, Typography, useTheme } from '@mui/material'
import { useMemo } from 'react'

import useIsPartner from '~/features/partners/hooks/useIsPartner'
import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { ESiteImagesTypes } from '~/features/partners/models'
import { getImgUrlByType } from '~/features/partners/utils'
import {
  EChatbotTheme,
  ESettingsStepFriendlyNames,
} from '~/features/settings/models'
import { EMarketingClientPath } from '~/models/api'
import { store } from '~/store'
import rem, {
  getWhiteOrBlackTextColorByBackground,
  isColorLight,
} from '~/utils/ui'

type TProps = {
  isChatbotPreview?: boolean
}
function LogoAndFooterText({ isChatbotPreview = false }: TProps) {
  const theme = useTheme()
  const isPartner = useIsPartner()
  const chatbotLayout = store((state) =>
    isChatbotPreview
      ? state.settings.steps[ESettingsStepFriendlyNames.chatbot]?.layout
      : state.chatbot.layout,
  )
  const { partner } = usePartnerCentralized()

  const footerBackgroundColor = useMemo(() => {
    if (chatbotLayout?.selection.theme === EChatbotTheme.linkView) {
      return chatbotLayout.options[chatbotLayout.selection.theme][
        chatbotLayout.selection[chatbotLayout.selection.theme]
      ].mainBackgroundColor
    }
    return theme.palette.mainFont
  }, [chatbotLayout, theme])

  const logoUrl = getImgUrlByType(
    isColorLight(footerBackgroundColor)
      ? ESiteImagesTypes.logoDark
      : ESiteImagesTypes.logoLight,
    partner,
  )

  const getFooterTextColor = () => {
    return getWhiteOrBlackTextColorByBackground(footerBackgroundColor, theme)
  }

  return (
    <Stack
      sx={{
        flexDirection: 'column',
        alignItems: 'flex-end',
      }}
    >
      <Box
        component="img"
        src={logoUrl}
        alt="Logo"
        sx={{
          width: isChatbotPreview
            ? rem(100)
            : {
                xxxs: isPartner ? rem(90) : rem(80),
                md: isPartner ? rem(110) : rem(80),
              },
          height: '100%',
          maxHeight: rem(50),
          cursor: 'pointer',
        }}
        onClick={() => window.open(EMarketingClientPath.home, '_blank')}
      />
      <Typography
        sx={{
          fontSize: isChatbotPreview ? rem(9) : { xxxs: 10, md: 12 },
          textAlign: 'end',
          lineHeight: rem(12),
          color:
            chatbotLayout?.selection.theme === EChatbotTheme.linkView
              ? getFooterTextColor()
              : theme.palette.common.white,
        }}
      >
        {partner.partnerName} uses AI and can make mistakes
      </Typography>
    </Stack>
  )
}

export default LogoAndFooterText
